import React, { useEffect } from "react";

import { useConfig } from "../../../data/useConfig";
import { useFilters } from "../../../data/useFilters";
import { useSearchResults } from "../../../data/useSearchResults";

import SearchInput from "../../SearchInput/Input";
import SkeletonFilter from "../../Filters/Skeleton";
import SkeletonResults from "../Skeleton";

import { handleEventSearchTerm } from "../../../utils/helpers";
import useMobileDetector from "../../../utils/useMobileDetector";
import { SearchContainer } from "./styles";

const DEFAULT_NOTFOUND_TITLE =
  "<h2>Não encontramos resultados para sua pesquisa</h2>";
const DEFAULT_ERROR_TITLE =
  "<h2>Houve um problema, tente novamente no campo abaixo</h2>";

const NotFound = () => {
  const { notFoundConfigs = {} } = useConfig();
  const { error, isLoading: isLoadingFilters, search } = useFilters();
  const { error: searchError, isLoading } = useSearchResults();
  const { isMobile } = useMobileDetector();

  const { customCss, displaySearch, titleTemplate } = notFoundConfigs;

  const NOT_FOUND_TITLE = titleTemplate || DEFAULT_NOTFOUND_TITLE;

  const setDocumentTitle = () => {
    const regex = /<[^>]*>([^<]+)<\/[^>]*>/g;
    const title = regex.exec(NOT_FOUND_TITLE);

    if (title) {
      document.title = title[1];
    }
  };

  useEffect(() => {
    setDocumentTitle();

    handleEventSearchTerm({
      action: "text",
      term: search,
      resultsCount: 0,
    });
  }, []);

  if (isLoading || isLoadingFilters)
    return (
      <div
        style={{
          display: "flex",
          maxWidth: "1200px",
          margin: "0 auto",
          marginTop: "30px",
        }}
      >
        {isMobile ? (
          <>
            <SkeletonResults />
            <SkeletonResults />
          </>
        ) : (
          <>
            <SkeletonFilter />
            <SkeletonResults />
          </>
        )}
      </div>
    );

  const titleHTML = {
    __html: error || searchError ? DEFAULT_ERROR_TITLE : NOT_FOUND_TITLE,
  };

  return (
    <SearchContainer
      className="beon-showcase--search-container"
      customCss={customCss}
    >
      <div
        className="beon-notfound--title-container"
        dangerouslySetInnerHTML={titleHTML}
      />
      {displaySearch && <SearchInput onSubmit={false} noTerm={true} />}

      <div className="beon-notfound--showcase-area" />
    </SearchContainer>
  );
};

export default NotFound;
